import { ConversationLog } from '../../../../../conversation/conversation-log/conversation-log';

import { CONVERSATION_SESSION_EVENTS_COLLECTION_NAME } from './conversation-session-events-collection-name';

export const getConversationSessionEventsCollection = (orgId: string, conversationLogId: string) =>
  `${ConversationLog.getSchema().getCollection(orgId)}/${conversationLogId}/${CONVERSATION_SESSION_EVENTS_COLLECTION_NAME}`;
